import { PaginationState, SortingState } from '@tanstack/react-table';
import { z } from 'zod';

export const ImportTypeLocationSchema = z.object({
	importTypeCompLocXRefId: z.number().nullable().optional(),
	importTypeId: z.number(),
	compLocId: z.number(),
	brandName: z.string().nullable().optional(),
});

export type ImportTypeLocation = z.infer<typeof ImportTypeLocationSchema>;

export type Location = {
	compLocId: number;
	brandName: string;
};

export const all = async (
	pagination: PaginationState,
	sorting: SortingState = [],
	importTypeId: number,
	params: object,
): Promise<{ data: ImportTypeLocation[]; total: number }> => {
	let queryString = '';
	if (params) {
		const paramsAsString = JSON.stringify(params)
			.replace(/:/g, '=')
			.replace(/,/g, '&')
			.replace(/[{}"]/g, '');

		const searchParams = new URLSearchParams(paramsAsString);
		if (pagination) {
			searchParams.append('pageSize', pagination.pageSize.toString());
			searchParams.append('pageIndex', pagination.pageIndex.toString());
		}

		if (sorting.length > 0) {
			searchParams.append('sortBy', sorting[0].id);
			searchParams.append('sortDirection', sorting[0].desc ? 'desc' : 'asc');
		}

		queryString = `?${searchParams.toString()}`;
	}

	const response = await fetch(
		`/admin/import-type/${importTypeId}/locations${queryString}`,
	);

	return await response.json();
};

export const getActiveLocations = async (): Promise<Location[]> => {
	const response = await fetch(`/admin/locations`);
	return await response.json();
};

export const add = async (location: ImportTypeLocation): Promise<boolean> => {
	const res = await fetch(
		`/admin/import-type/${location.importTypeId}/locations`,
		{
			method: 'POST',
			body: JSON.stringify(location),
			headers: {
				'Content-Type': 'application/json',
			},
		},
	);
	return res.ok;
};

export const update = async (lookup: ImportTypeLocation): Promise<boolean> => {
	const res = await fetch(`/admin/import-type/${lookup.importTypeId}/locations`, {
		method: 'PATCH',
		body: JSON.stringify(lookup),
		headers: {
			'Content-Type': 'application/json',
		},
	});
	return res.ok;
};
